module.exports = __webpack_public_path__ + "img/JAOC_POP_CheddarCheese_square.29628516.png";